import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import CardSystem from '../../Card/CardSystem';
import Armature from '../../../Prototype/Armature';
import { AwaitIterators, PlayAnimation } from '../AnimationHelper';
import {
    CardColor,
    cardColorBySuit,
    Suit,
} from 'Utility/CardsHelper';
import { MainAnim } from './MainAnim';
import { Easing } from '@tweenjs/tween.js';
import { DragonbonesFadeIn } from './DragonbonesFadeIn';
import TransformComponent from '../../../Component/Transform';
import CardComponent from 'Component/Level/Card';

interface ICardDestroyMetaData {
    system: CardSystem;
    suit: Suit;
}

export class CardDestroy extends AnimationClip {
    public *execute(gameObject: GameObject, meta: ICardDestroyMetaData): IterableIterator<number> {
        const animsToPlay = [];

        const cardColor: CardColor = cardColorBySuit[meta.suit];
        const color: string = cardColor === CardColor.Red ? 'red' : 'black';

        const cardArmature: Armature = GameObject.Instantiate(Armature, {
            name: 'cardArmature',
            dragonbonesName: `card_destroy_${color}`,
            armatureName: 'Armature',
            alpha: 0,
            playOnStart: false,
        });
        gameObject.parent.addChild(cardArmature);

        const cardArmatureTransform = cardArmature.getComponent(TransformComponent);
        const gameObjectTransform = gameObject.getComponent(TransformComponent);
        cardArmatureTransform.position.copy(gameObjectTransform.position);
        cardArmatureTransform.rotation = gameObjectTransform.rotation;

        animsToPlay.push(
            PlayAnimation(
                new MainAnim(
                    gameObject,
                    {
                        alpha: 0,
                        duration: 600,
                        easing: Easing.Sinusoidal.Out,
                    },
                    true
                )
            )
        );

        animsToPlay.push(
            PlayAnimation(
                new DragonbonesFadeIn(cardArmature, {
                    playTimes: 1,
                    fadeInTime: 200,
                })
            )
        );

        yield* AwaitIterators(animsToPlay);
        cardArmature.destroy();
        gameObject.getComponent(CardComponent).animating = false;
    }
}
